(function( $ ) {
	//imgix 
	var options = {
		updateOnPinchZoom : true,
		fitImgTagToContainerWidth: true,
		fitImgTagToContainerHeight: false,
		lazyLoad: true,
		onLoad: function(el) {
			console.log($(el).outerWidth());
			if ( $(el).hasClass('product-gallery') ) {
				$(el).parent().addClass('imgix-loaded');
			}
		}
	};

	imgix.onready(function() {
		imgix.fluid(options);
	});

	function loadImgixImg(el) {
		var $img = el,
			sMax = $img.data('max'),
			nMaxWidth = (Math.ceil($img.parent().outerWidth() / 25) * 25),
			nMaxHeight = (Math.ceil($img.parent().outerHeight() / 25) * 25),
			sSRC = $img.data('src'),
			nDPR = Math.ceil(window.devicePixelRatio);

		var nDPR = (nDPR > 2) ? 2 : nDPR;

		if( sMax == 'width' ) {
			var sImgixSRC = sSRC+'&w='+nMaxWidth+'&dpr='+nDPR;
		} else if( sMax == 'height' ) {
			var sImgixSRC = sSRC+'&h='+nMaxHeight+'&dpr='+nDPR;
		}

		$img.attr('src', sImgixSRC).addClass('img-loaded');
	}

	function initImgixImages() {
		$('.imgix-img').each(function() {
			loadImgixImg($(this));
		})
	}

	function loadImgixBg(el) {
		var $this = el,
			nWidth = (Math.ceil($this.outerWidth() / 25) * 25),
			nHeight = (Math.ceil($this.outerHeight() / 25) * 25),
			sSRC = $this.data('src'),
			sFit = $this.data('fit'),
			nDPR = Math.ceil(window.devicePixelRatio),
			sImgixSRC = sSRC+'&w='+nWidth+'&h='+nHeight+'&fit='+ sFit +'&dpr='+nDPR;

		var img = new Image();

		img.onload = function() {
			$this.css('background-image', 'url('+sImgixSRC+')').addClass("bg-img-loaded");
			//the callback function call here
		};

		img.src = sImgixSRC;
	}

	function initImgixBgImages() {
		$('.imgix-bg-img').each(function() {
			loadImgixBg($(this));
		})
	}

    function initImgix() {
		initImgixBgImages();
		initImgixImages();
	}

	var imgixBgImagesTimeout;

    $(document).ready(function() {
		initImgix();
	})
	
    $(window).resize(function() {
		window.clearTimeout(imgixBgImagesTimeout);
		imgixBgImagesTimeout = window.setTimeout(initImgix, 50);
	})

})(jQuery);
